import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { ToggleGroupCard, ToggleGroupCardItem } from '@/components/ui/toggle-group';

import { activationNotificationOptionsRich } from '../model';

type Props = {
  onActivationNotificationChange: (value: boolean | null) => void;
  activationNotification: boolean;
};

const ActivationNotification = ({ onActivationNotificationChange, activationNotification }: Props) => {
  const onChange = (value: string) => onActivationNotificationChange(value === '' ? null : value === 'true');

  return (
    <Card>
      <CardHeader>
        <CardTitle>Activation notification</CardTitle>
        <CardDescription>
          Would you like to notify the beneficiary representatives when this escrow is activated?
        </CardDescription>
      </CardHeader>
      <CardContent>
        <ToggleGroupCard
          type="single"
          className="flex-col w-full"
          onValueChange={onChange}
          value={activationNotification.toString()}
        >
          {activationNotificationOptionsRich.map(({ value, icon: Icon, label, description }) => (
            <ToggleGroupCardItem key={value} value={value} icon={Icon} title={label} description={description} />
          ))}
        </ToggleGroupCard>
      </CardContent>
    </Card>
  );
};

export default ActivationNotification;
